"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Credit:
 * https://medium.com/@michaelchan_13570/using-react-router-v4-prompt-with-custom-modal-component-ca839f5faf39
 *
 * @param when?: boolean | undefined;
 * @param navigate: (path: string) => void;
 * @param shouldBlockNavigation: (location: Location) => boolean;
 *
 * @example
 * ...
 * render() {
 * ...
 *  <React.Fragment>
 *      // ...Other scene components
 *      <RouteLeavingGuard
 *         when={isDirty}
 *         navigate={path => history.push(path)}
 *         shouldBlockNavigation={location => {
 *            if (isDirty) {
 *              if (location.pathname === 'signup') {
 *                return true
 *              }
 *            }
 *            return false
 *         }}
 *      />
 *  </React.Fragment>
 * ...
 * }
 */
class UnsavedLeavingGuard extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      modalVisible: false,
      lastLocation: null,
      confirmedNavigation: false
    };

    this.windowConfirmLeave = e => {
      const {
        when
      } = this.props;

      if (when) {
        e.preventDefault();
        e.returnValue = true;
      }
    };

    this.setModalVisible = visible => {
      this.setState({
        modalVisible: visible
      });
    };

    this.setLastLocation = location => {
      this.setState({
        lastLocation: location
      });
    };

    this.setConfirmedNavigation = confirmed => {
      this.setState({
        confirmedNavigation: confirmed
      });
    };

    this.closeModal = () => {
      this.setModalVisible(false);
    };

    this.handleBlockedNavigation = nextLocation => {
      const {
        shouldBlockNavigation
      } = this.props;
      const {
        confirmedNavigation
      } = this.state;

      if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
        this.setModalVisible(true);
        this.setLastLocation(nextLocation);
        return false;
      }

      return true;
    };

    this.handleConfirmNavigationClick = () => {
      this.setModalVisible(false);
      this.setConfirmedNavigation(true);
    };
  }

  componentDidUpdate() {
    const {
      navigate
    } = this.props;
    const {
      confirmedNavigation,
      lastLocation
    } = this.state;

    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with navigate function
      navigate(lastLocation.pathname);
    }
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.windowConfirmLeave);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.windowConfirmLeave);
  }

  render() {
    const {
      when
    } = this.props;
    const {
      modalVisible
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Prompt, {
      when: when,
      message: this.handleBlockedNavigation
    }), /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: modalVisible,
      title: "Close without saving?",
      okText: "Leave",
      okType: "danger",
      onOk: this.handleConfirmNavigationClick,
      onCancel: this.closeModal
    }, "You have unsaved changes. Are you sure you want to leave this page without saving?"));
  }

}

var _default = UnsavedLeavingGuard;
exports.default = _default;